import { ListStoreDefault, ListRequestHandler, ListSuccessHandler, ListFilterHandler } from 'js/helpers/reducers';
import {
  FETCH_FOLLOWED_ENTITIES,
  FETCHED_FOLLOWED_ENTITIES,
  SET_FOLLOWED_ENTITIES_FILTER,
  FETCH_TRENDING_BRANDS,
  FETCHED_TRENDING_BRANDS,
  FETCH_TRENDING_PUBLISHERS,
  FETCHED_TRENDING_PUBLISHERS,
  FETCH_TRENDING_KEYWORDS,
  FETCHED_TRENDING_KEYWORDS,
  TOGGLE_COMING_SOON_MODAL,
} from 'components/Pages/Home/actions';

import { ONBOARDING_SHOWN } from 'actions/userAnalytics.js';

const defaultTrendingFilters = {
  pageNum: 1,
  pageSize: 18,
};

const defaultState = {
  followedEntitiesList: ListStoreDefault({
    pageNum: 1,
    pageSize: 6,
    searchQuery: '',
    searchBy: '',
  }),
  trendingBrandsList: ListStoreDefault(defaultTrendingFilters),
  trendingPublishersList: ListStoreDefault(defaultTrendingFilters),
  trendingKeywordsList: ListStoreDefault(defaultTrendingFilters),
  isModalToggled: {
    comingSoonReports: false,
    comingSoonEmailAlerts: false,
    comingSoonContentSharing: false,
    comingSoonInsightsExport: false,
  },
  showOnboarding: false,
};

const HomeReducer = (state = defaultState, action) => {
  switch (action.type) {
    case '@@router/LOCATION_CHANGE':
      return Object.assign({}, defaultState);
    case TOGGLE_COMING_SOON_MODAL:
      return Object.assign(state, {
        isModalToggled: { ...state.isModalToggled, ...{ [action.modal]: !state.isModalToggled[action.modal] } },
      });
    case FETCH_FOLLOWED_ENTITIES:
      return ListRequestHandler(state, action, 'followedEntitiesList');
    case FETCHED_FOLLOWED_ENTITIES:
      return ListSuccessHandler(state, action, 'followedEntitiesList');
    case SET_FOLLOWED_ENTITIES_FILTER:
      return ListFilterHandler(state, action, 'followedEntitiesList');
    case FETCH_TRENDING_BRANDS:
      return ListRequestHandler(state, action, 'trendingBrandsList');
    case FETCHED_TRENDING_BRANDS:
      return ListSuccessHandler(state, action, 'trendingBrandsList');
    case FETCH_TRENDING_PUBLISHERS:
      return ListRequestHandler(state, action, 'trendingPublishersList');
    case FETCHED_TRENDING_PUBLISHERS:
      return ListSuccessHandler(state, action, 'trendingPublishersList');
    case FETCH_TRENDING_KEYWORDS:
      return ListRequestHandler(state, action, 'trendingKeywordsList');
    case FETCHED_TRENDING_KEYWORDS:
      return ListSuccessHandler(state, action, 'trendingKeywordsList');
    case ONBOARDING_SHOWN:
      return { ...state, showOnboarding: true };
    default:
      return { ...state };
  }
};

export default HomeReducer;
